export default __webpack_public_path__ + "static/media/bg-topic-detail.7ee7167f.svg";